// extracted by mini-css-extract-plugin
export default {"spinner":"spinner_spinner__6LOe0","appear":"spinner_appear__FwQHl"};